<div class="document-bulk-container">

  <form [formGroup]="documentFormGroup">
    <div class="p-grid p-fluid ">
      <div class="p-col-6 p-md-6 p-lg-6">
        <div class="label-block">
          <form-factory [formGroup]="documentFormGroup" [model]="documentNotes"></form-factory>
        </div>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button text="CONTINUE TO VALIDATION" (onClick)="validateToShowDocumentGrid()"></app-button>
      </div>
    </div>
  </form>
  <ng-container *ngIf="isDocumentGrid">
  <div class="p-grid p-fluid" *ngIf="isShowValidateDocumentGridData">
    <div class="p-col-12 p-md-12 p-lg-12">
      <app-basic-grid [configuration]="documentServerGridConfiguration"
                      [data]="data">
      </app-basic-grid>
    </div>
    <div class="p-grid p-fluid finish-bulk-update-container">
      <div class="p-col-12 p-md-12 p-lg-12">
        <app-button (onClick)="finalBulkUpdate()" text="FINISH BULK UPDATE" [disabled]="isFinalBulkUpdate"></app-button>
      </div>
    </div>
  </div>
  </ng-container>
</div>
